import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth";
import { registerServiceWorker } from "./pwa";
import { initializeTheme } from "./theme";
import { lockBrowserZoom } from "./zoomLock";
import App from "./App";
import "@fontsource-variable/source-sans-3/wght.css";
import "@fontsource-variable/fraunces/wght.css";
import "./styles.css";
import "./styles/brand-elevations.css";

initializeTheme();
lockBrowserZoom();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

if (import.meta.env.PROD) {
  registerServiceWorker().catch(console.warn);
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .catch(console.warn);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
